import { render, staticRenderFns } from "./LandingStreamfield.vue?vue&type=template&id=49854efe&scoped=true"
import script from "./LandingStreamfield.vue?vue&type=script&lang=js"
export * from "./LandingStreamfield.vue?vue&type=script&lang=js"
import style0 from "./LandingStreamfield.vue?vue&type=style&index=0&id=49854efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49854efe",
  null
  
)

export default component.exports